module.exports = __webpack_public_path__ + "img/autospin_btn.49127efd.png";